import { jsx as r } from "react/jsx-runtime";
import "react";
function o({ children: t }) {
  return t === null ? /* @__PURE__ */ r("ul", {}) : /* @__PURE__ */ r("ul", { children: t.length && t.map((u) => u) });
}
export {
  o as ChoicesList,
  o as default
};
